import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, CardActions, CardAction, TextField } from 'rmwc';
import { Text } from '../components/Text';
import { signInUser, signOutUser } from '../actions/userActions';

export class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: {
        value: '',
        error: false,
      },
      password: {
        value: '',
        error: false,
      },
    };
  }

  _onChange(field, e) {
    const update = {};
    update[field] = {
      value: e.target.value,
      error: false,
    };
    this.setState(Object.assign({}, this.state, update));
  }

  _signin = e => {
    e.preventDefault();
    this.props.dispatch(signInUser(this.state.email.value, this.state.password.value)).then(() => {
      this.props.onSuccess();
    });
  };

  _signout = e => {
    e.preventDefault();
    this.props.dispatch(signOutUser());
  };

  render() {
    return (
      <div>
        <Card>
          {this.props.user.is_guest ? (
            <form onSubmit={this._signin}>
              <div className="hrbr-full-width-controls p-3">
                <Text use="headline5">Log in to your account</Text>
                {this.props.error != '' && <Text use="body1">{this.props.error}</Text>}
                <div>
                  <TextField
                    label="Email"
                    value={this.state.email.value}
                    onChange={this._onChange.bind(this, 'email')}
                  />
                </div>
                <div>
                  <TextField
                    label="Password"
                    type="password"
                    value={this.state.password.value}
                    onChange={this._onChange.bind(this, 'password')}
                  />
                </div>
              </div>
              <CardActions>
                <CardAction theme="secondary-bg on-secondary" raised>
                  Sign In
                </CardAction>
              </CardActions>
            </form>
          ) : (
            <form onSubmit={this._signout}>
              <div>
                <Text use="headline6">Log in to your account</Text>
                <Text use="body1" className="mt-2">
                  Already signed in.
                </Text>
              </div>
              <CardActions>
                <CardAction unelevated>Sign Out</CardAction>
              </CardActions>
            </form>
          )}
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    error: state.user.sign_in_error,
  };
}

export default connect(mapStateToProps)(SignIn);
